import styled from "@emotion/styled";
import { Button } from "react-aria-components";

export const StyledWrapper = styled.div<{ $isVisible: boolean }>(({ $isVisible }) => ({
  opacity: $isVisible ? 1 : 0,
  bottom: $isVisible ? 10 : -65,
  display: "flex",
  flex: 1,
  justifyContent: "center",
  position: "absolute",
  transition: "all 0.2s cubic-bezier(0.34, 1.56, 0.64, 1)",
  left: 16,
  right: 16,
  maxWidth: "calc(100% - 32px)",
  zIndex: 2,
}));

export const StyledSwitchFloaty = styled(Button)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["2"]};
  padding-block: ${({ theme }) => theme.spacing["2"]};
  padding-inline: ${({ theme }) => theme.spacing["3"]};
  border-radius: ${({ theme }) => theme.borderRadius.xlarge};
  box-shadow: ${({ theme }) => theme.shadows.surface};
  background-color: ${({ theme }) => theme.colors.background.button.default.default};

  transition: 0.25s ease;

  &:active {
    transform: scale(0.99);
    background-color: ${({ theme }) => theme.colors.background.button.emphasisLight.default};
    color: ${({ theme }) => theme.colors.text.emphasis};
  }

  &[data-selected="true"] {
    background-color: ${({ theme }) => theme.colors.background.button.emphasisLight.default};
    color: ${({ theme }) => theme.colors.text.emphasis};

    &:hover {
      background-color: ${({ theme }) => theme.colors.background.button.emphasisLight.hover};
    }

    .mds-icon {
      color: ${({ theme }) => theme.colors.text.emphasis};
    }
  }

  &:disabled {
    cursor: none;
    pointer-events: none;
    background-color: ${({ theme }) => theme.colors.background.button.default.default};
  }
`;

export const StyledLeftContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing["2"]};
`;

export const StyledRightContainer = styled.div`
  display: flex;
  align-items: center;
`;
